/* eslint-disable react-hooks/exhaustive-deps */
import { useApolloClient } from "@apollo/client";
import Button from "@mostrans/web-components/components/base/Button";
import FormGroup from "@mostrans/web-components/components/base/FormGroup";
import Input from "@mostrans/web-components/components/base/Input";
import Radio from "@mostrans/web-components/components/base/Radio";
import { Box, Card, CardContent, CardHeader, Paper, Typography } from "@mui/material";
import { isEmpty } from "lodash";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useSetState } from "react-use";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import Loading from "../../../components/Loading";
import Success from "../../../components/Success";
import { CreateCandidatePreAssessment } from "../../../graphql/mutations";
import { getCandidateByID } from "../../../graphql/query";
import { getDetailCandidate } from "../../../shared/atom/detailCandidate";
import { globalLoadingAtom, globalSuccessAtom } from "../../../shared/globalStates";
import { toastError, toastSuccess } from "../../../shared/helpers";

export const PreAssesment = () => {
  const history = useHistory();
  const client = useApolloClient();
  const [candidate, setDetailCandidate] = useRecoilState(getDetailCandidate);
  const setLoading = useSetRecoilState(globalLoadingAtom);
  const [preAssesment, setPreAssesment] = useState(false);

  const [success, setSuccess] = useRecoilState(globalSuccessAtom);
  const [selected, setSelected] = useState(null);
  const [empty, setEmpty] = useState(false);
  const [values, setValues] = useSetState({
    answer1: "",
    answer2: "",
    answer3: "",
    answer4: selected,
    answer5: null,
  });
  useEffect(() => {
    setLoading(true);
    if (isEmpty(candidate)) {
      getCandidateByID(client).then((response) => {
        setDetailCandidate(response);
        setPreAssesment(response.is_pre_assessment_done);
        setLoading(false);
      });
    } else {
      setPreAssesment(candidate.is_pre_assessment_done);
      setLoading(false);
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (
      !values.answer1 ||
      !values.answer2 ||
      !values.answer3 ||
      values.answer4 === null ||
      (selected && !values.answer5)
    ) {
      setEmpty(true);
      toastError("Error, please input all requirements");
    } else {
      setLoading(true);
      const result = await CreateCandidatePreAssessment(client, values);
      setLoading(false);
      if (result.status !== "000") {
        toastError("Error, try again later!");
      } else {
        toastSuccess("Success, Thank you for completing preassessment");
        setDetailCandidate({
          ...candidate,
          is_pre_assessment_done: true,
        });
        setSuccess(true);
      }
    }
  };

  var title = "PreAssessment";
  var text = "You have completed the preassessment, we will contact you as soon as possible. ";
  var subtext = "Thank you for your participation. Page will be moved in";
  var route = "ASSESMENT";

  return success ? (
    <Success title={title} text={text} subtext={subtext} timer={15000} route={route} button />
  ) : (
    <React.Fragment>
      {preAssesment ? (
        <Information />
      ) : (
        <Box fontSize={14} maxWidth="md" margin="auto">
          <form>
            <Paper sx={{ padding: "50px" }}>
              <Box>
                <Typography textAlign="center" variant="h1" component="h1" marginBottom={2}>
                  Pre-Assesment Mostrans
                </Typography>
                <p className="text-textSecondary" style={{ marginBottom: "20px" }}>
                  Anda diminta mengisi pertanyaan-pertanyaan di bawah ini secara lengkap berdasarkan
                  pengalaman yang Anda miliki.
                </p>
              </Box>
              <FormGroup
                showChildErrorSign
                errorMessage={"Pertanyaan ini tidak boleh kosong"}
                isError={empty && !values.answer1}
                isRequired
                style={{ marginBottom: "15px" }}
                label="Ceritakanlah kejadian atau masalah yang pernah anda alami di dalam pekerjaan (boleh di tempat kerja saat ini atau di tempat kerja sebelumnya) yang dampak atau hasilnya Anda rasakan sebagai sukses besar atau kepuasan bagi diri Anda. (Apabila anda freshgraduate maka boleh memberikan pengalaman selama masa pendidikan).">
                <Input
                  type="text"
                  placeholder="Jelaskan dengan detail"
                  onChange={(e) =>
                    setValues({
                      answer1: e.target.value === "-" ? null : e.target.value,
                    })
                  }
                  multiline
                  required={true}
                />
              </FormGroup>
              <FormGroup
                showChildErrorSign
                errorMessage={"Pertanyaan ini tidak boleh kosong"}
                isError={empty && !values.answer2}
                isRequired
                style={{ marginBottom: "15px" }}
                label="Ceritakanlah kejadian atau masalah yang pernah Anda alami di dalam pekerjaan (boleh di tempat kerja saat ini atau di tempat kerja sebelumnya) yang dampak atau hasilnya Anda rasakan sebagai suatu kegagalan besar atau ketidakpuasan bagi Anda.">
                <Input
                  type="text"
                  placeholder="Jelaskan dengan detail"
                  onChange={(e) =>
                    setValues({
                      answer2: e.target.value === "-" ? null : e.target.value,
                    })
                  }
                  multiline
                  required
                />
              </FormGroup>
              <FormGroup
                showChildErrorSign
                errorMessage={"Pertanyaan ini tidak boleh kosong"}
                isError={empty && !values.answer3}
                isRequired
                style={{ marginBottom: "15px" }}
                label="Ceritakan secara terperinci improvement/perbaikan yang telah Anda lakukan selama ini, baik di tempat kerja saat ini atau di tempat kerja sebelumnya.">
                <Input
                  type="text"
                  placeholder="Jelaskan dengan detail"
                  onChange={(e) =>
                    setValues({
                      answer3: e.target.value === "-" ? null : e.target.value,
                    })
                  }
                  multiline
                  required
                />
              </FormGroup>
              <FormGroup
                showChildErrorSign
                errorMessage={"Silahkan pilih salah satu pilihan!"}
                isError={empty && values.answer4 === null}
                isRequired
                style={{ marginBottom: "15px" }}
                label="Apakah Anda pernah / sedang diproses di Kalbe Group?">
                <label>
                  <Radio
                    checked={selected === true}
                    onChange={() => {
                      setSelected(true);
                      setValues({ ...values, answer4: true });
                    }}
                  />
                  Ya
                </label>
                <label>
                  <Radio
                    checked={selected === false}
                    onChange={() => {
                      setSelected(false);
                      setValues({ ...values, answer4: false });
                    }}
                  />
                  Tidak
                </label>
              </FormGroup>
              {selected && (
                <FormGroup
                  showChildErrorSign
                  errorMessage={"Pertanyaan ini tidak boleh kosong"}
                  isError={empty && !values.answer5}
                  isRequired
                  style={{ marginBottom: "15px" }}
                  label="Apabila anda pernah/sedang di proses di Kalbe Group, silahkan sebutkan company-nya.">
                  <Input
                    type="text"
                    placeholder="Sebutkan nama perusahaannya "
                    onChange={(e) =>
                      setValues({
                        answer5: e.target.value === "-" ? null : e.target.value,
                      })
                    }
                    required
                  />
                </FormGroup>
              )}

              <Box textAlign="center">
                <Button
                  onClick={() => history.goBack()}
                  variant="contained"
                  color="danger"
                  style={{ marginRight: "50px" }}>
                  Kembali
                </Button>
                <Button type="submit" onClick={handleSubmit} variant="contained" color="primary">
                  Kirim
                </Button>
              </Box>
            </Paper>
          </form>
        </Box>
      )}
    </React.Fragment>
  );
};

export const Information = () => {
  const history = useHistory();
  const loading = useRecoilValue(globalLoadingAtom);
  const handleBack = () => {
    history.goBack();
  };

  return loading ? (
    <Loading />
  ) : (
    <Card
      className="shadow-soft-s3"
      variant="outlined"
      sx={{
        width: "100vh",
        margin: "auto",
      }}>
      <CardHeader
        sx={{ textAlign: "center", justifyContent: "center" }}
        title={
          <Box component="div">
            <span
              className={`material-icons ${"text-danger-main"}`}
              style={{ fontSize: "50px", padding: "10px 0" }}>
              info
            </span>
            <p className={`font-weight-w600 font-size-h4 ${"text-danger-main"}`}>
              Anda sudah selesai mengerjakan PreAssesment
            </p>
          </Box>
        }
      />
      <CardContent sx={{ textAlign: "center" }}>
        <Typography>
          Maaf kamu tidak diperkenankan untuk mengerjakan test lebih dari 1 kali
        </Typography>
        <Typography>Terjadi kesalahan? Hubungi HRD jika terjadi kesalahan.</Typography>
        <Box textAlign="center" py={2}>
          <Button
            onClick={() => handleBack()}
            sx={{ margin: "10px 0" }}
            variant="contained"
            color="danger">
            Kembali
          </Button>
        </Box>
      </CardContent>
    </Card>
  );
};
